export enum ImageTypes {
  content = 'CONTENT',
  userProfile = 'USER_PROFILE',
}

export enum ImageUploadError {
  inappropriate = 'INAPPROPRIATE',
  tooLarge = 'TOO_LARGE',
  unsupportedType = 'UNSUPPORTED_TYPE',
  imageNotFound = 'IMAGE_NOT_FOUND',
  presignedFailed = 'PRESIGNED_FAILED',
}

export interface GetImagePresignedRequest {
  marketplaceId: string;
  imageNames: Array<string>;
  imageType: ImageTypes
}

export interface GetImagePresignedResponse {
  imageUrls: Array<string>;
}

export interface ProcessImagesRequest {
  marketplaceId: string;
  unvalidatedUrls: Array<string>;
  imageType: ImageTypes
}

export interface ProcessImagesResponse {
  imageResults: Record<string, ImageResult>;
}

export interface ImageResult {
  valid: boolean;
  validatedUrl?: string,
  failureCode?: string,
}

export interface ImageUploadRequest {
  files: { [key: string]: { file: File } },
  imageType: ImageTypes,
}

export interface ImageUploadAPIRequest {
  imageNames: string[],
  marketplaceId: string,
  imageType: ImageTypes,
}

export interface ProcessImageAPIRequest {
  unvalidatedUrls: string[],
  marketplaceId: string,
  imageType: ImageTypes,
}

export enum KatFileUploadStatus {
  ready = 'ready',
  uploading = 'uploading',
  complete = 'complete',
  error = 'error',
}

export type FileState = {
  file: File,
  status: KatFileUploadStatus,
  url?: string,
  error?: string,
};

export type FilesState = {
  [key: string]: FileState
};
